export default __webpack_public_path__ + "static/media/21.ee12c110.jpg";